// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import App from './src/App'
import router from './src/router/index.js'
import clipboard from 'clipboard'
import './static/js/lib/directive.js'
import './static/js/lib/ie9placeholder.js'
import ElementUI from 'element-ui'
import message from './static/js/lib/resetMessage.js'
import store from 'store'
import './static/less/index.less'
import 'element-ui/lib/theme-chalk/index.css'
import './static/less/element-reset.less'
import 'babel-polyfill'
import Cookie from 'js-cookie'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.prototype.$message = message
Vue.prototype.clipboard = clipboard // 复制粘贴功能

// 全局修改tooltip组件,自定义的依然有效
ElementUI.Tooltip.props.transition.default = ''
ElementUI.Tooltip.props.openDelay.default = 300

// 全局store
store.dispatch('getLanguage') // 获取当前语言
const i18n = new VueI18n({
  locale: store.state.lenovoData.language || 'zh', // 语言标识
  messages: {
    zh: require('./static/js/language/zh.js'), // 中文
    en: require('./static/js/language/en.js'), // 英文
    tw: require('./static/js/language/tw.js'), // 繁体
    ja: require('./static/js/language/ja.js'), // 日文
  },
})
locale.i18n((key, value) => i18n.t(key, value)) // 为了实现element插件的多语言切换
router.beforeEach(async (to, from, next) => {
  await store.dispatch('getBoxType')
  await store.dispatch('getBoxUserInfo')
  await store.dispatch('getCustomizeInfo')
  const toPath = to.fullPath
  applicationCheck(to, next)
  const apiReg = /^(\/(api|sdk)\/*)/
  const edasReg = /^(\/edas\/*)/
  const isHideLogin = store.getters.boxType !== 'private'
  const isHasRouteAuth = store.state.lenovoData.customize.use_marne_platform === 'true'
  const isPublic = store.getters.boxType === 'public'
  if (isPublic && !isHasRouteAuth) {
    message.error('您所访问的页面不存在，或页面已删除')
    setTimeout(() => {
      window.location.href = '/'
    }, 1000)
    return
  }
  if (isHideLogin && to && to.path === '/login') {
    next('/edas/agent')
  } else if (apiReg.test(toPath)) {
    const goback = localStorage.getItem('goback')
    if (goback) {
      if (goback === '/api/ProductGuide') {
        localStorage.setItem('currentMenu', '/api/ProductGuide')
      }
      if (goback === '/sdk/downloadSDK') {
        localStorage.setItem('currentMenu', '/api/downloadSDK')
      }
      localStorage.removeItem('goback')
      next({ path: goback })
    } else {
      localStorage.setItem('currentMenu', toPath)
    }
    next()
  } else if (edasReg.test(toPath)) {
    localStorage.removeItem('currentMenu')
    if (!isHideLogin && !Cookie.get('S') && to && to.path !== '/login') {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

function applicationCheck(to, next) {
  const applicationHide = store.getters.applicationHide
  const integratedShow = store.getters.integratedShow
  if (to.meta.applicationHide || to.meta.integratedHidden) {
    if (
      to.meta.applicationHide === applicationHide ||
      to.meta.integratedHidden === integratedShow
    ) {
      next()
    } else {
      next({ path: '/edas' })
    }
  }
}

window.app = new Vue({
  el: '#edas',
  router,
  store,
  i18n,
  render: h => h(App),
})

// 前端错误统一收集
window.onerror = function onError(message, url, line, column, error) {
  console.log('log---onerror::::', message, url, line, column, error)
}



// WEBPACK FOOTER //
// ./main.js